import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { IoSearch, IoCloseSharp } from "react-icons/io5";
import { ConfigContext, TranslateContext } from "../../App";
import config from "../../configuration.json";
import { fetchData } from "../../functions/utils";
import { searchResultsGROQ } from "../../functions/GROQ";

const Search = () => {
  const configuration = useContext(ConfigContext);
  const language = useContext(TranslateContext).language;
  const [activeInput, setActiveInput] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearchClick = () => {
    setActiveInput(true);
  };

  const handleXClick = () => {
    setActiveInput(false);
    setQuery("");
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      navigate(`/search?query=${query}`);
    }
  };

  return (
    <div className="search-container w-full bg-white flex items-center justify-center">
      <div className="w-full lg:w-[1140px] flex items-center justify-start px-[15px] lg:px-0">
        <button
          onClick={!activeInput ? handleSearchClick : handleXClick}
          className="search-icon bg-none border-none cursor-pointer text-2xl"
        >
          {activeInput && query ? (
            <IoCloseSharp color={configuration.colors?.main?.hex} />
          ) : (
            <IoSearch color={configuration.colors?.main?.hex} />
          )}
        </button>
        <input
          onClick={handleSearchClick}
          type="text"
          value={query}
          onChange={handleInputChange}
          onKeyDown={handleKeyPress}
          className="search-input p-2 outline-none w-full"
          placeholder={config.texts.searchPlaceHolder[language]}
        />
      </div>
    </div>
  );
};

export default Search;
